import React, { Component } from 'react'
import cx from 'classnames'
import './styles.css'

export default class Sidebar extends Component {
  state = {
    tweetsLoaded: false,
  }

  componentDidMount() {
    setTimeout(() => {
      if (window.twttr) {
        window.twttr.widgets.createTimeline({
          sourceType: 'profile',
          screenName: 'knick_hill',
        }, document.getElementById('twitterSidebar'))
        this.setState({ tweetsLoaded: true })
      }
    }, 1500)
  }

  render() {
    return (
      <aside className={cx('sidebar-container')}>
        <section className={cx('twitter-section')}>
          <h3>Latest Tweets</h3>
          {!this.state.tweetsLoaded && (<div>Loading Tweets...</div>)}
          <div id='twitterSidebar' />
        </section>
      </aside>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/components/sidebar/index.js